export const ORIENTATION_ANGLE_FLOAT_DECIMAL_COUNT = 1
export const VOLTAGE_FLOAT_DECIMAL_COUNT = 3
export const TEMPERATURES_FLOAT_DECIMAL_COUNT = 2
export const COORDINATE_DEGREE_DECIMAL_COUNT = 3
export const SIGNAL_TO_NOISE_DECIMAL_COUNT = 2
export const FREQUENCY_DECIMAL_COUNT = 3
export const ALL_EDITOR_DECIMAL_COUNT = 3
